import { HTTPAPI } from "../base";

const grabToken = () => {
    const uInfoTxt = localStorage.getItem("userInfo");    
    let uInfo = null;
    if(uInfoTxt) {
        uInfo = JSON.parse(uInfoTxt);
    }
    const token = uInfo != null ? uInfo.token : "";
    return token;
}

const entityurikey = 'audience';

const audience = {
    getList: (urlCriteria) => {        
        return HTTPAPI(grabToken())
        .get("/" + entityurikey + "/list" + urlCriteria)
    },
    getAll: () => {        
        return HTTPAPI(grabToken())
        .get("/" + entityurikey)
    },
    delete: (code) => {        
        return HTTPAPI(grabToken())
        .delete("/" + entityurikey + "/" + code)
    },
    getOne: (code) => {        
        return HTTPAPI(grabToken())
        .get("/" + entityurikey + "/" + code)
    },
    update: (code, data) => {
        return HTTPAPI(grabToken())
        .patch("/" + entityurikey + "/" + code, data);
    },
    create: (data) => {
        return HTTPAPI(grabToken())
        .post("/" + entityurikey + "/", data);
    },
}

export default audience;
